import './icons'

import StatusBox from './components/status-box/index.vue'

function install (app) {
  app.component('McStatusBox', StatusBox)
}

export {
  install,
  StatusBox
}
